import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';
import FileSaver from 'file-saver';

@Service()
export default class InvoicesService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;
    public async get(
        invoiceNumber: string,
        sendersName: string,
        clientName: string,
        providerName: string,
        paymentDateFrom: string,
        paymentDateTo: string,
        isExport: boolean,
        pageIndex: string,
        pageSize: string
    ): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const baseURL = isExport
                ? 'api/payment-transaction/exportgetall'
                : 'api/payment-transaction/getall';

            const params = new URLSearchParams({
                invoiceNumber,
                sendersName,
                clientName,
                providerName,
                paymentDateFrom,
                paymentDateTo,
                pageIndex,
                pageSize
            });

            const url = `${window.$config.HostName}${baseURL}?${params.toString()}`;
            const result = await this.axiosService.axiosInstance.get(url);

            if (result.data.isSuccess && isExport) {
                const array = Buffer.from(result.data.result, 'base64');
                const blob = new Blob([array], { type: 'application/vnd.ms-excel' });
                FileSaver.saveAs(blob, 'invoiceReport.xlsx');
            }

            return result.data.isSuccess ? result.data : false;
        } catch (error) {
            return false;
        } finally {
            this.loaderService.HideLoader();
        }
    }


    public async downloadIvnoice(
        transactionReference: string,
        isBalanceInvoice: boolean): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/payment-transaction/downloadinvoice' +
                '?invoiceIdentifier=' + transactionReference
                + '&isBalanceInvoice=' + isBalanceInvoice;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
}
